<template>
  <div class="report user-month">

    <b-row>
      <b-col>

        <b-form-group
            label="Year">
          <select-box :options="years"
                      v-model="selected.year"
                      placeholder="Year"
                      :multiple="false"
                      :allow-empty="false"
          ></select-box>
        </b-form-group>
      </b-col>

      <b-col>
        <b-form-group
            label="Month">
          <select-box :options="$get('system/getMonths')"
                      v-model="selected.month"
                      placeholder="Month"
                      :multiple="false"
                      :allow-empty="false"
          ></select-box>
        </b-form-group>
      </b-col>

      <b-col>
        <b-form-group label="Day">
          <select-box :options="$get('system/getDays')"
                      v-model="selected.day"
                      placeholder="Day"
                      :multiple="false"
                      :allow-empty="false"
          ></select-box>
        </b-form-group>
      </b-col>
    </b-row>

    <b-tabs @input="setActiveWorkspace" v-if="workspaces.length">
      <b-tab v-for="(ws, k) in workspaces" :title="ws.title" class="" :key="k" lazy>

        <template v-if="activeWorkspaceId">
          <div class="efficiency">

            <div>
              <h4>Total efficiency: <b
                  v-html="getEfficiency((100 * reportData.effective / reportData.scheduled).toFixed(1), '%')"/>
                <i>({{ reportData.effective.toFixed(1) }} / {{ reportData.scheduled.toFixed(1) }})</i></h4>
              <hr/>
              Scheduled time: <b>{{ reportData.scheduled.toFixed(1) }}h</b>,
              Logged time:
              <b>{{ reportData.logged.toFixed(1) }}h</b>({{
                (100 * reportData.logged / reportData.scheduled).toFixed(1)
              }}%),
              Effective time: <b>{{ reportData.effective.toFixed(1) }}h</b>({{
                (100 * reportData.effective / reportData.logged).toFixed(1)
              }}%)
            </div>


            <!--div class="logged">Logged: <b>{{loggedHours.toFixed(2)}}h</b></div>
            <div class="estimated">Estimated: <b>{{effectiveHours.toFixed(2)}}h</b></div!-->
          </div>

          <hr/>

          <b-row>
            <b-col cols="9">
              <bar-chart :key="selected.year+'-'+selected.month.id" v-if="Object.values(reportData['report']).length==1"
                         :labels="dates"
                         :datasets="hours" :height="300" :width="800"></bar-chart>

              <line-chart :key="selected.year+'-'+selected.month.id"
                          v-else-if="Object.values(reportData['report']).length"
                          :labels="dates" @item-click="itemClick"
                          :datasets="hours" :height="300" :width="800"></line-chart>
            </b-col>
            <b-col cols="3">
              <pie-chart :key="selected.year+'-'+selected.month.id" v-if="Object.values(reportData['report']).length"
                         :labels="['Assignee', 'Acceptor', 'Support']"
                         :height="250"
                         :datasets="statisics"></pie-chart>
            </b-col>
          </b-row>

          <h2 class="mt-3">Tasks list</h2>

          <b-table sort-by="spent" :sort-desc="true" stickyColumn striped hover :items="reportTasks" :fields="[
        {key: 'task_title', label: 'Task', thStyle: 'width:400px;'},
        //{key: 'estimate_time', label: 'Estimate'},
        {key: 'hours', label: 'Spent time', sortable: true, sortDirection: 'desc'},
        {key: 'role'},
         {key: 'state'}]"
                   @row-clicked="gotoTask">

            <template v-slot:cell(role)="data">
              {{ data.item.assignee ? "assignee " : "" }}
              {{ data.item.acceptor ? "acceptor " : "" }}
              {{ data.item.support ? "support " : "" }}
            </template>

            <template v-slot:cell(state)="data">
              {{ getStateTitle(data.item.state) }}
            </template>

          </b-table>
        </template>
      </b-tab>
    </b-tabs>

  </div>
</template>

<script>
import SelectBox from "../../components/SelectBox";
import LineChart from "@/components/charts/LineChart";
import BarChart from "@/components/charts/BarChart";
import PieChart from "@/components/charts/PieChart";
import {api} from "@/utils/api";

export default {

  components: {
    PieChart,
    SelectBox,
    LineChart,
    BarChart
  },

  // Properties
  props: {
    user_id: {},
    year: {
      default: function () {
        return new Date().getFullYear();
      }
    },
    month: {
      default: function () {
        return new Date().getMonth() + 1;
      }
    },
    day: {default: 0}
  },

  watch: {
    'selected.year': 'dateChanged',
    'selected.day': 'dateChanged',
    'selected.month': 'dateChanged',
    'activeWorkspaceId': 'updateReport'
  },

  data() {
    return {
      // Chart data
      years: [2019, 2020],
      selected: {
        month: '',
        year: 0,
        day: 0,
      },

      reportData: {report: [], effective: 0, logged: 0, scheduled: 0},
      reportTasks: [],
      loggedHours: 0,
      effectiveHours: 0,
      userWorkspaces: [],
      activeWorkspaceId: 0,
      loaded: false
    }
  },

  computed: {

    /**
     * Workspaces list
     */
    workspaces() {

      // Init list
      const wsList = [];

      // Load workspace names
      for (const ws of this.userWorkspaces) {
        const wsData = this.$get("tree/loadTaskFieldByID", {id: ws.workspace_id, field: 'rendered_title'});
        if (wsData) {
          const nItm = Object.assign({}, ws)
          nItm.title = wsData;
          wsList.push(nItm);

          // Check if active workspace set
          //if(!this.activeWorkspaceId) this.setActiveWorkspace(ws.workspace_id)
        }
      }

      // Workspaces list
      return wsList
    },

    /**
     * Dates
     */

    dates() {
      // Return dates
      return Object.keys(this.reportData['report']);
    },

    /**
     * Hours
     */

    hours() {

      // Return hours
      return [
        {
          label: 'Effective time',
          backgroundColor: '#f00a',
          data: this.$api.pluck(this.reportData['report'], 'effective')
        },
        {
          label: 'Total logged time',
          backgroundColor: '#0f0a',
          data: this.$api.pluck(this.reportData['report'], 'hours')
        },
        {
          label: 'Scheduled time',
          backgroundColor: '#00f3',
          data: this.$api.pluck(this.reportData['report'], 'scheduled')
        },
      ];
    },

    /**
     * Statistics
     */

    statisics() {

      // Return hours
      return [
        {
          label: 'Effective time',
          backgroundColor: ['#0a0', '#00a', '#a00'],
          data: [this.reportData['assignee_effective'].toFixed(1), this.reportData['acceptor_effective'].toFixed(1), this.reportData['other_effective'].toFixed(1)]
        },
      ];
    }
  },

  // Mounted items
  mounted() {

    // Load workspaces list
    api.call(false, 'get', `/api/workspace/${this.user_id}/list`).then((wss) => {
      this.userWorkspaces = wss;
    })

    // Define initial params
    this.selected.month = parseInt(this.month);
    this.selected.year = parseInt(this.year);
    this.selected.day = parseInt(this.day);
    this.years = [];
    Array.from(Array(11).keys()).map(n => {
      this.years.push({id: 2019 + n, title: 2019 + n});
    });

    // Load report
    this.updateReport();
  },

  // Methods list
  methods: {

    /**
     * Set active workspace
     * @param id
     */
    setActiveWorkspace(index) {
      this.activeWorkspaceId = this.workspaces[index].workspace_id;
    },

    /**
     * Get efficiency
     * @param val
     */
    getEfficiency(val, leg) {
      let color = 'black';
      if (val > 90) color = '#0a0';
      if (val < 90) color = '#aa0';
      if (val < 70) color = '#a00';

      // Return ddata
      return '<span style="color:' + color + '">' + val + leg + '</span>';
    },

    /**
     * Return state title
     * @param state
     * @returns {string}
     */
    getStateTitle(state) {
      switch (state) {
        case 10:
          return "open";
        case 5:
          return "wait";
        case 30:
          return "acceptance";
        case 100:
          return "closed";
      }
    },

    /**
     * Update url
     */
    dateChanged() {
      this.$emit('date-changed', this.selected);
    },

    /**
     * Click handler
     * @param item
     */
    itemClick(item) {
      this.selected.day = item.index + 1;
      this.updateReport();
    },

    /**
     * Go to task
     */

    gotoTask(row) {
      let route = this.$router.resolve('/tree/' + row.task_id);
      window.open(route.href, '_blank');
    },

    /**
     * Get efficiency class
     */

    getEffClass() {

      // Percent
      const pr = 100 * this.effectiveHours / this.loggedHours;

      // Error
      if (pr < 90) return '#a00';

      // Warning
      if (pr < 100) return '#aa0';

      // Success
      if (pr >= 100) return '#0a0';

    },

    /**
     * Update report
     */
    updateReport() {

      // Reset data
      this.reportData = {report: [], effective: 0, logged: 0, scheduled: 0};

      // No active workspace
      if(!this.activeWorkspaceId) return;

      // Loader
      this.loaded = false;

      // Load report for user
      this.$dispatch("timelog/loadMonthReport", {
        workspace_id: this.activeWorkspaceId,
        user_id: this.user_id,
        month: parseInt(this.selected.month),
        day: parseInt(this.selected.day),
        year: this.selected.year
      }).then((data) => {
        // Store current report
        this.reportData = data;
      });

      // Reset tasks data
      this.reportTasks = [];

      // Load report for user
      this.$dispatch("timelog/loadUsersTasksReport", {
        workspace_id: this.activeWorkspaceId,
        user_id: this.user_id,
        month: parseInt(this.selected.month),
        day: parseInt(this.selected.day),
        year: parseInt(this.selected.year)
      }).then((data) => {
        // Store current report
        this.reportTasks = data;

        // Loaded
        this.loaded = true;
      });

    }
  }
}

</script>


<style lang="scss">

.user-month {
  min-height: 400px;

  .efficiency {
    margin-top:20px;

    hr {
      margin: 4px 0px 4px 0px;
    }

    i {
      font-size: 12px;
    }
  }
}

</style>
